import { render, staticRenderFns } from "./NewDriverFingerprintFile.vue?vue&type=template&id=38c90eaa&scoped=true&"
import script from "./NewDriverFingerprintFile.vue?vue&type=script&lang=js&"
export * from "./NewDriverFingerprintFile.vue?vue&type=script&lang=js&"
import style0 from "./NewDriverFingerprintFile.vue?vue&type=style&index=0&id=38c90eaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c90eaa",
  null
  
)

export default component.exports